import React from 'react';

import {Property} from '../../utilTypes';
import {DOT, getDisplayName, propertyMapToList} from './util';

type NestedOverridesProps = {
  property: Property;
  getElementForProperty: (property: Property) => any;
};

export const NestedOverrides = ({
  property,
  getElementForProperty,
}: NestedOverridesProps) => {
  const subProperties: Property[] = propertyMapToList(
    property.properties,
    property.key,
    property.file
  );
  let bgColor = 'bg-white';
  if ((property.key.match(DOT) || []).length % 2 === 0) {
    bgColor = 'bg-moon-50';
  }
  return (
    <>
      <div
        className="w-fit items-center rounded px-4 text-sm font-normal leading-6 text-sienna-500"
        style={{fontFamily: 'Source Code Pro, monospace'}}>
        {getDisplayName(property)}
      </div>
      <div className="my-10 text-sm font-normal leading-6 text-moon-500">
        {property.description}
      </div>
      <div
        className={`my-10 w-full rounded border border-moon-250 ${bgColor} p-12`}>
        {subProperties.map((subProperty, idx, arr) => {
          return (
            <>
              {getElementForProperty(subProperty)}

              {idx < arr.length - 1 && (
                <div className="m-[20px_-12px] h-px w-auto bg-moon-250" />
              )}
            </>
          );
        })}
      </div>
    </>
  );
};
